import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 12,
    borderRadius: 12,
    border: `1px solid ${theme.palette.grey[500]}`,
    padding: 4
  },
  title: { fontSize: 18, fontWeight: 500 },
  mainRow: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between'
  },
  flex: {
    display: 'flex',
    alignItems: 'center'
  },
  gap: {
    marginLeft: 30
  },
  tableHead: {
    padding: '8px 0 8px 50px',
    width: '100%',
    display: 'grid',
    background: theme.palette.grey[200],
    gridTemplateColumns: '9fr 2fr 2fr 2fr 2fr'
  },
  resetIcon: { fontSize: 20 }
}))
export default useStyles
